var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
import { TextInput } from 'src/ui/components/Input/TextInput/TextInput';
/**
 * Work well in case of simple paths.
 * For objects properties of multiple levels of depths,
 * overriding by using classic <TextInput> props may be needed
 * @param validIdentityModalInfo All the ValidIdentityModal data needed
 * @param path Object key path.
 * @param onChange side effects triggered on input value changes
 * @param specificValidationKey when mapping between currentIdentity & currentValidation don't match
 * @param additionnalProps all potential props from classic <TextInput> component that needs to be specified, can be used to override default behavior
 * @returns
 */
export var TextInputValidIdentity = function (props) {
    var validIdentityModalInfo = props.validIdentityModalInfo, path = props.path, onChange = props.onChange, specificValidationKey = props.specificValidationKey, label = props.label, additionnalProps = __rest(props, ["validIdentityModalInfo", "path", "onChange", "specificValidationKey", "label"]);
    var i18n = validIdentityModalInfo.i18n, currentIdentity = validIdentityModalInfo.currentIdentity, currentIdentityModified = validIdentityModalInfo.currentIdentityModified, currentValidation = validIdentityModalInfo.currentValidation, getInputHint = validIdentityModalInfo.getInputHint;
    var value = getPropsByKeyPath(currentIdentity, path);
    var modifiedValue = getPropsByKeyPath(currentIdentityModified, path);
    var validationValue = getPropsByKeyPath(currentValidation, specificValidationKey !== null && specificValidationKey !== void 0 ? specificValidationKey : path);
    var givenKeyLabel = label !== null && label !== void 0 ? label : getPropsByKeyPath(i18n.keyValueMap, "caseGlobalView.modals.identityValidation.inputLabels.".concat(path));
    var isGivenKeyValueChanged = value !== modifiedValue;
    return (_jsx(TextInput, __assign({ value: modifiedValue, onChange: onChange, label: givenKeyLabel, withInfo: isGivenKeyValueChanged || validationValue.isError, isError: validationValue.isError, infoMessage: validationValue.isError ? validationValue.infoMessage : getInputHint(value || '') }, additionnalProps)));
};
